import { render } from "./TasteTest.vue?vue&type=template&id=3c61d99b&scoped=true"
import script from "./TasteTest.vue?vue&type=script&lang=js"
export * from "./TasteTest.vue?vue&type=script&lang=js"

import "./TasteTest.vue?vue&type=style&index=0&id=3c61d99b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c61d99b"

export default script